interface ReviewCardProps {
  author: string;
  avatar?: string;
  rating: number;
  headline: string;
  content: string;
  date: string;
  userType: string;
  faded?: boolean;
}

export default function ReviewCard({
  author,
  avatar,
  rating,
  headline,
  content: reviewContent,
  date,
  userType,
  faded,
}: ReviewCardProps) {
  return (
    <div
      className={`bg-background-200 rounded-2xl p-5 flex flex-col ${
        faded ? 'opacity-50' : ''
      }`}
    >
      <div className="flex items-center gap-1 mb-3">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="w-4 h-4 flex items-center justify-center">
            <i
              className={`text-sm ${
                i < rating ? 'text-primary-500 ri-star-fill' : 'text-foreground-300 ri-star-line'
              }`}
            ></i>
          </div>
        ))}
      </div>
      <h4 className="text-foreground-950 font-bold text-base mb-2">
        {headline}
      </h4>
      <p className="text-foreground-600 text-sm leading-relaxed flex-1 mb-4">
        {reviewContent}
      </p>
      <div className="flex items-center gap-3">
        {avatar ? (
          <img
            src={avatar}
            alt={author}
            className="w-9 h-9 rounded-full object-cover"
            loading="lazy"
          />
        ) : (
          <div className="w-9 h-9 rounded-full bg-primary-500/20 flex items-center justify-center">
            <i className="ri-user-line text-primary-400 text-sm"></i>
          </div>
        )}
        <div>
          <p className="text-foreground-950 font-semibold text-sm">{author}</p>
          <p className="text-foreground-500 text-xs">
            {userType} · {date}
          </p>
        </div>
      </div>
    </div>
  );
}